import _ from 'lodash';

import { GET_SETTINGS, UPDATE_SETTINGS } from 'admin/constants';

export const initialState = {
	fetching: false,
};

export default function settingsReducer(state = initialState, action) {
	if (action.type === GET_SETTINGS.START || action.type === UPDATE_SETTINGS.START) {
		return {
			...state,
			fetching: true,
		};
	}

	if (action.type === GET_SETTINGS.FAIL || action.type === UPDATE_SETTINGS.FAIL) {
		return {
			...state,
			fetching: false,
		};
	}

	if (action.type === GET_SETTINGS.SUCCESS) {
		const payload = _.get(action, 'payload', {});
		const nextState = _.mapValues(payload, (v, k) => ({
			...state[k],
			...v,
		}));

		return {
			...state,
			...nextState,
			fetching: false,
		};
	}

	if (action.type === UPDATE_SETTINGS.SUCCESS) {
		const nextState = action.payload || {};
		return {
			...state,
			...nextState,
			fetching: false,
		};
	}

	return state;
}
